
























import Vue from 'vue';
import { Component } from 'vue-property-decorator';

import EnterpriseSetting from './components/enterprise-setting.vue';
import EnterpriseUser from './components/enterprise-user.vue';
import PersonalSetting from './components/personal-setting.vue';
import EnterpriseRight from './components/enterprise-right.vue';

import { GetUserInfo } from '../../api/login/index';
@Component({
  components: { EnterpriseSetting, EnterpriseUser, PersonalSetting, EnterpriseRight },
})
export default class Index extends Vue {
  activeSlide = 0;
  roleCodeList = [];
  slideList = [] as any;
  mounted() {
    GetUserInfo().then(res => {
      this.roleCodeList = res.roleCodeList;
      if ((this.roleCodeList as any).includes('enterpriseAdmin')) {
        this.slideList = [
          {
            icon: 'https://cdn-h.gongfudou.com/Epson/tab_1.png',
            selcetedIcon: 'https://cdn-h.gongfudou.com/Epson/tab_1_active.png',
            title: '企业信息设置',
          },
          {
            icon: 'https://cdn-h.gongfudou.com/Epson/tab_5.png',
            selcetedIcon: 'https://cdn-h.gongfudou.com/Epson/tab_5_active.png',
            title: '企业权益管理',
          },
          {
            icon: 'https://cdn-h.gongfudou.com/Epson/tab_2.png',
            selcetedIcon: 'https://cdn-h.gongfudou.com/Epson/tab_2_active.png',
            title: '企业员工管理',
          },
          {
            icon: 'https://cdn-h.gongfudou.com/Epson/tab_3.png',
            selcetedIcon: 'https://cdn-h.gongfudou.com/Epson/tab_3_active.png',
            title: '个人信息设置',
          },
        ];
      } else {
        this.slideList = [
          {
            icon: 'https://cdn-h.gongfudou.com/Epson/tab_3.png',
            selcetedIcon: 'https://cdn-h.gongfudou.com/Epson/tab_3_active.png',
            title: '个人信息设置',
          },
        ];
      }
    });
  }

  handleTab(index: number) {
    this.activeSlide = index;
  }
}
